import type { MarketConfig } from '../../types';

export const academyInConfig = {
  slug: 'aca-in-accs',
  label: 'Academy India',
  country: 'IN',
  language: 'en',
  siteSection: 'ACA_IN',
  cms: 'AzureSWA',
  title: 'Advanced Certificate in Cyber Security | TÜV SÜD Academy India',
  description:
    'Lead generation landing page for the Advanced Certificate in Cyber Security career path by TÜV SÜD Academy India.',
  themeColor: '#001a3a',
  ogImage: 'https://mango-grass-0099f4103.6.azurestaticapps.net/favicon.png',
  ogImageAlt: 'TÜV SÜD Academy India cybersecurity lead generation landing page preview image',
  twitterCard: 'summary_large_image',
  robots: 'noindex,nofollow',
} satisfies MarketConfig;
